import * as React from "react";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { LtlFreightItemClassWeightPiecesRow } from "./LtlFreightItemClassWeightPiecesRow";
import { LtlFreightItemPackagingRow } from "./LtlFreightItemPackagingRow";

type ItemRow = LTLState["items"][number];

interface LtlFreightItemPrimaryRowProps {
  item: ItemRow;
  index: number;
  state: LTLState;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
  maxWeight?: number;
}

export function LtlFreightItemPrimaryRow({
  item,
  index,
  state,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
  maxWeight,
}: LtlFreightItemPrimaryRowProps): React.ReactElement {
  return (
    <>
      <LtlFreightItemClassWeightPiecesRow
        item={item}
        index={index}
        state={state}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
        maxWeight={maxWeight}
      />
      <LtlFreightItemPackagingRow
        item={item}
        index={index}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
      />
    </>
  );
}
